// extracted by mini-css-extract-plugin
module.exports = {"asidex":"Courses_asidex__2PEv7"};